export function Logo({ href = "/" } = {}) {
  const logo = document.createElement("a");

  logo.className = "site-logo";
  logo.href = href;
  logo.setAttribute("aria-label", "The Lazy Company");

  logo.innerHTML = `
    <span class="site-logo__the">the</span>
    <span class="site-logo__lazy">LAZY</span>
    <span class="site-logo__company">company</span>
  `;

  return logo;
}
